<template>
  <v-card flat>
    <v-layout class="pb-0 pt-2" justify-start row wrap>
      <v-text-field
        class="pa-3 ma-3"
        v-model="search"
        append-icon="search"
        label="Поиск"
        single-line
      ></v-text-field>


      <v-layout justify-end row wrap>
        <v-btn @click="getItems()" color="primary">
          <v-icon class="material-icons">
            autorenew
          </v-icon>
        </v-btn>
        <v-btn @click="updateItem()" color="primary">
          <v-icon class="material-icons">
            add
          </v-icon>
        </v-btn>
      </v-layout>

    </v-layout>

    <v-card flat class="pb-0 pt-0">

      <v-card-text class="pb-0 pt-0">
        <v-layout justify-center>
          <v-flex>
            <v-data-table

              :headers="headers"
              :items="items"
              :rows-per-page-items="[5,15,35,{text:'Все', value:-1}]"
              class="elevation-1  "
              no-data-text="Нет данных"
              rows-per-page-text="Число элементов"
            >
              <template slot="items" slot-scope="props">
                <td class="justify-center">{{props.item.fio}}</td>
                <td class="justify-center">{{props.item.birth}}</td>
                <td class="justify-center">{{props.item.citizenship}}</td>
                <td class="justify-center">{{props.item.academic_degree}}</td>
                <td class="justify-center">{{props.item.status}}</td>
                <td class="justify-center">{{props.item.speciality}}</td>
                <td class = justify-center>

                <v-icon  v-if="props.item.publications !== null"
                         @click="goToPathItem(props.item.publications)"
                >cloud_download</v-icon>
                <v-icon  v-else >close</v-icon>

                </td>
                <td class="justify-center " v-bind="selected">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        @click="updateItem(props.item)"
                        class="mr-2"
                        medium
                      >
                        edit
                      </v-icon>
                    </template>
                    <span>Редактировать</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        @click="openConfirmDelete(props.item)"
                        medium
                      >
                        delete
                      </v-icon>
                    </template>
                    <span>Удалить</span>
                  </v-tooltip>
                </td>
              </template>
              <template slot="pageText" slot-scope="item">
                {{item.pageStart}} - {{item.pageStop}} из {{item.itemsLength}}
              </template>
              <template slot="no-data">
                <v-btn @click="getItems()" color="primary">Обновить</v-btn>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-dialog @input="closedForm" v-model="opened_form" fullscreen hide-overlay transition="dialog-bottom-transition" persistent>
      <Publications @addItem="addItem"
             @ended="closedForm"
             @refreshItem="refreshItem"
             v-bind:petition=petition :selected="selected"
             v-if="opened_form"
      >
      </Publications>
    </v-dialog>

    <v-dialog persistent v-model="opened_confirm" width="500">
      <v-card v-if="deletable">
        <v-card-title>Подтвердите удаление</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          Вы уверены что хотите удалить?<br>
        </v-card-text>
        <v-card-actions>
          <v-flex>
            <v-btn
              @click="deleteItemSetting(deletable.id)"
              color="warning"
              flat
            >
              Удалить
            </v-btn>
            <v-btn
              @click="closeConfirmDelete"
              flat
            >Отмена
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout row wrap>
      <v-flex md6>
        <v-btn block class="primary" @click="printListPDF"  v-if="allowed('admin|petition|petition|petition_create_permanent_council|candidate-make-file', 'make_file')">
          <span v-if="!show_loadind">
            Сформировать PDF списка кандидатов
          </span>
          <span v-else style="padding-left: 65px; width: 149px; align-content: center; text-align: center;">
            <semipolar-spinner
              :animation-duration="2000"
              :size="20"
              color="#1935ff"
            />
          </span>
        </v-btn>

      </v-flex>
      <v-flex md6>
        <v-btn block class="primary" @click="printPersonalsPDF" v-if="allowed('admin|petition|petition|petition_create_permanent_council|candidate-make-personals-file', 'make_personals_file')"  >
          <span v-if="!show_loadind">
            Сформировать PDF каждого кандидата
          </span>
          <span v-else style="padding-left: 65px; width: 149px; align-content: center; text-align: center;">
            <semipolar-spinner
              :animation-duration="2000"
              :size="20"
              color="#1935ff"
            />
          </span>
        </v-btn>
      </v-flex>

    </v-layout>

  </v-card>
</template>

<script>
  import urls from "../../urls.js"

  import UserDataMixin from '../../../../mixins/UserDataMixin'
  import {makeGetRequest, makePostRequest, makeProfileUrl} from "../../../../helper";
  import Publications from "@/modules/petition/forms/Publications.vue"

  import {SemipolarSpinner} from 'epic-spinners'

    export default {
        name: "PublicationsList",
        components: {SemipolarSpinner, Publications},

        mixins: [UserDataMixin],
        props: {
            local_admin: Boolean,
            petition: Number,
            activetab: String
        },
        data: function () {
            return {
                selected: {},
                opened_form: false,
                generatePdf: true,
                show_loadind: false,
                search: '',
                statisttic: {},
                departments: [],
                headers: [
                    {
                        text: 'ФИО',
                        align: 'justify-center',
                        sortable: true,
                        value: 'fio',
                    },
                    {
                        text: 'Дата рождения',
                        align: 'justify-center',
                    },
                    {
                        text: 'Страна',
                        align: 'justify-center',
                    },
                    {
                        text: 'Ученая степень',
                        align: 'justify-center',
                    },
                    {
                        text: 'Статус в совете',
                        align: 'justify-center',
                    },
                    {
                        text: 'Шифр науч спец,представляемой в совете',
                        align: 'justify-center',
                    },
                    {
                        text: 'Файл публикаций',
                        align: 'justify-center',
                    },
                    {
                        text: 'Действия',
                        align: 'justify-center',
                    },

                ],

                URL_LIST: makeProfileUrl(urls.getUrl('admin|petition|petition|petition_create_permanent_council|candidate-list', 'list')),
                URL_DELETE: makeProfileUrl(urls.getUrl('admin|petition|petition|petition_create_permanent_council|candidate-detail', 'destroy')),
            }
        },

        watch: {
            $props: {
                handler() {
                    if(this.activetab ==="tab-2")
                        if(this.petition !== undefined)
                            this.getItems();

                },
                deep: true,
                immediate: true,
            },
        },
      methods: {
          deleteItemSetting(item){
              this.URL_DELETE = this.URL_DELETE.replace('<petition>', this.petition)
              this.deleteItem(item)
          },
          download(content, fileName, contentType) {
              var a = document.createElement("a");
              a.href = URL.createObjectURL(content);
              a.download = fileName;
              a.click();
          },
          printListPDF() {
              this.generatePdf = true;
              this.show_loadind = true;
              let status = true;
              const type = "application/pdf";
              const name = 'file.pdf';
              makeGetRequest(
                  urls.getUrl('admin|petition|petition|petition_create_permanent_council|candidate-make-file', 'make_file').replace('<petition>', this.petition),
              ).then(resp => {
                  if (!resp.ok) {
                      status = false;
                  }
                  return resp.blob();
              }).then(blob => {
                  this.download(blob, name, type);
                  this.generatePdf = false;
                  this.show_loadind = false;
              })
          },

          printPersonalsPDF() {
              this.generatePdf = true;
              this.show_loadind = true;
              let status = true;
              const type = "application/pdf";
              const name = 'file.pdf';
              makeGetRequest(
                  urls.getUrl('admin|petition|petition|petition_create_permanent_council|candidate-make-personals-file', 'make_personals_file').replace('<petition>', this.petition),
              ).then(resp => {
                  if (!resp.ok) {
                      status = false;
                  }
                  return resp.blob();
              }).then(blob => {
                  this.download(blob, name, type);
                  this.generatePdf = false;
                  this.show_loadind = false;
              })
          },
        getItems: function () {
          let url = makeProfileUrl(
            this.URL_LIST.replace('<petition>', this.petition)
          );
          makeGetRequest(url)
            .then(resp => {
              return resp.json()
            }).then(json => {
              let list = json;

                this.items = list;
                this.loadingPage = true;

          });
        },
        updateItem: function (item) {
          this.selected = item;
          this.opened_form = true
        },
        closedForm: function () {
          this.selected = {};
          this.opened_form = false
          if(this.petition !== undefined)
              this.getItems();
        },
        allowed(urlname, action) {
          return urls.getUrlAllowed(urlname, action)
        },
        goToPath(path){
          this.$router.push({name: "DetailApplication", params: {id: path.id}})
        },
        goToPathItem(path){
              window.location=path;
        },

      },
      created() {
        this.$store.commit('mainpage/changeTitle', 'Список поданых заявлений:');
          if(this.petition !== undefined)
            this.getItems();

      },

    }
</script>

<style scoped>

</style>
